import { render, staticRenderFns } from "./OrganizationAccessList.vue?vue&type=template&id=b26b56f4&scoped=true&"
import script from "./OrganizationAccessList.vue?vue&type=script&lang=js&"
export * from "./OrganizationAccessList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationAccessList.vue?vue&type=style&index=0&id=b26b56f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26b56f4",
  null
  
)

export default component.exports